/**
 * Extract user turn texts from a run-report case's recorded exchanges.
 *
 * @param {Object} caseItem
 * @returns {string[]}
 */
export const extractReportCaseUserMessages = (caseItem) => {
  const exchanges = Array.isArray(caseItem?.exchanges) ? caseItem.exchanges : [];
  return exchanges.map((exchange) => (exchange?.message ?? '').trim()).filter(Boolean);
};

/**
 * Build a plan-style case object using report exchange user messages.
 * Falls back to the supplied plan case when the report has no user turns.
 *
 * @param {Object} reportCase
 * @param {Object|null} planCase
 * @returns {Object|null}
 */
export const buildReportDrivenPlanCase = (reportCase, planCase) => {
  if (!planCase) return null;
  const reportMessages = extractReportCaseUserMessages(reportCase);
  if (reportMessages.length === 0) return planCase;
  return { ...planCase, messages: reportMessages };
};
